import { useMutation, useQueryClient } from '@tanstack/react-query'
import axios from '@pepper/utils/src/function/axiosInstance'
import { SEO_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'
import { Topic, BatchTopic } from '@pepper/utils/src/types/seo'

type Parameters = {
  companyId: string
  projectId: string
  data: BatchTopic[]
  flow?: 'crr'
}

type ReturnType = {
  status: 'failure' | 'success'
  records?: Topic[]
  message?: string
  new_record_ids?: string[] | null
  description?: string
}

const addBatchTopics = async ({
  companyId,
  projectId,
  data,
  flow
}: Parameters): Promise<ReturnType> => {
  try {
    const url = `${SEO_SERVICE_BASE_URL}/companies/${companyId}/topics/batch`
    const response = await axios.post(url, {
      project_id: projectId,
      data,
      flow
    })
    return response.data
  } catch (error) {
    return error
  }
}

export const useCreateBulkTopics = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (params: Parameters) => addBatchTopics(params),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['project-topics']
      })
      queryClient.invalidateQueries({
        queryKey: ['project-domain-map']
      })
    }
  })
}
